import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=a9bb4092&scoped=true&"
import script from "./MessagesTable.vue?vue&type=script&lang=js&"
export * from "./MessagesTable.vue?vue&type=script&lang=js&"
import style0 from "./MessagesTable.vue?vue&type=style&index=0&id=a9bb4092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb4092",
  null
  
)

export default component.exports